<form class="form-horizontal" [formGroup]="signatureForm">
    <div class="config-section">
        <div class="card">
            <div class="card-header">
                <h5>Search Signature</h5>
            </div>
            <div class="search-signature-common">                
                <div class="card-body">                
                    <div class="search-signature-panel">                        
                        <div class="contract-session-div">
                            <label class="control-label" for="holidayName">Contract Session Id<span style="color:red">&nbsp;*</span></label>
                            <input type="text" id="csId" class="form-control" formControlName="csId" maxlength="8" (keypress)="allowNumeric($event)" trimWhiteSpace />
                            <button class="btn btn-success" title="Search Signature" (click)="searchByCsId()">
                                <i class="fa fa-search" aria-hidden="true" style="padding-right:5px;"></i>Search
                                <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                            </button>
                        </div>
                    </div>
               
                    <div *ngIf="isData">
                        <div class="signature-table-panel">
                            <mat-tab-group>
                                <mat-tab label="Signature List">                                    
                                    <div class="card nmi-table">
                                        <div class="card-header">
                                            <h5>Signature List</h5>
                                        </div>
                                        <div class="card-body">
                                            <div class="mat-container mat-elevation-z2" style="max-height:650px; overflow-y: scroll;">
                                                <table class="table table-bordered">
                                                    <tr>
                                                        <th scope="col">Type</th>
                                                        <th scope="col">SOC</th>
                                                        <th scope="col">ADS</th>
                                                        <th scope="col">Final</th>
                                                    </tr>
                                                    <tr *ngFor="let sl of signatureListResponse">
                                                        <th scope="row">{{sl.type}}</th>
                                                        <td><img [src]="sl.soc" class="zoom" /></td>
                                                        <td><img [src]="sl.ads" class="zoom" /></td>
                                                        <td><img [src]="sl.final" class="zoom" /></td>
                                                    </tr>
                                                    <tr *ngFor="let sl of signatureListResponse">
                                                        <th scope="row">{{sl.type}}-Initial</th>
                                                        <td>{{sl.socinitial}}</td>
                                                        <td>{{sl.adsinitial}}</td>
                                                        <td>{{sl.finalinitial}}</td>
                                                    </tr>
                                                </table>
                                            </div>                                                
                                        </div>
                                    </div>
                                </mat-tab>
                                <mat-tab label="Signature Audit List">                                    
                                    <div class="card nmi-table">
                                        <div class="card-header">
                                            <h5>Signature Audit List</h5>
                                        </div>
                                        <div class="card-body">
                                            <div style="border:solid 1px transparent;">
                                                <div class="mat-container mat-elevation-z2" style="max-height:750px; overflow-y: scroll;">
                                                    <table class="table table-bordered">
                                                        <tr>
                                                            <th scope="col">Type</th>
                                                            <th scope="col">SOC</th>
                                                            <th scope="col">ADS</th>
                                                            <th scope="col">Final</th>
                                                        </tr>
                                                        <tr *ngFor="let sl of signatureAuditListResponse">
                                                            <th scope="row">{{sl.type}}</th>
                                                            <td><img [src]="sl.soc" class="zoom" /></td>
                                                            <td><img [src]="sl.ads" class="zoom" /></td>
                                                            <td><img [src]="sl.final" class="zoom" /></td>
                                                        </tr>
                                                        <tr *ngFor="let sl of signatureAuditListResponse">
                                                            <th scope="row">{{sl.type}} Initial</th>
                                                            <td>{{sl.socinitial}} </td>
                                                            <td>{{sl.adsinitial}} </td>
                                                            <td>{{sl.finalinitial}} </td>
                                                        </tr>

                                                    </table>

                                                </div>
                                                <!--</div>-->
                                            </div>
                                        </div>
                                    </div>
                                </mat-tab>
                            </mat-tab-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
